import { isUndNullEmpNew } from '../../helpers/UtilsHelper';

export class RoleSessionClass {
    constructor(
        id = '',
        description = '',
        created = new Date()?.toISOString(),
        userId = '',
        isAdmin = false,
        isMaster = false,
        isAnonymous = false,
        isUser = false,
    ) {
        this.id = id;
        this.description = description;
        this.created = created;
        this.userId = userId;
        this.isAdmin = isAdmin;
        this.isMaster = isMaster;
        this.isAnonymous = isAnonymous;
        this.isUser = isUser;
    }

    getIsAdminOrMaster = () => {
        return this?.isMaster || this?.isAdmin;
    }

    static getClassName = () => {
        return 'Role session - class';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this.getClassName(), })?.result) {
            return new RoleSessionClass(
                obj?.id,
                obj?.description,
                obj?.created,
                obj?.userId,
                obj?.isAdmin,
                obj?.isMaster,
                obj?.isAnonymous,
                obj?.isUser,
            );
        }

        return new RoleSessionClass();
    }
}